// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608062110/js/" + chunkId + "." + {"44":"93b5f096","225":"29ad99e6","481":"1220dba4","486":"efd30443","770":"3d46535e"}[chunkId] + ".0.07323554532526133.chunk.js";
};